// with polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/';
import i18n from './locales';
import { VueAxios } from './utils/request';
import ProLayout, { PageHeaderWrapper } from '@ant-design-vue/pro-layout';
import themePluginConfig from '../config/themePluginConfig';

// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
// import './mock';

import bootstrap from './core/bootstrap';
// import './core/use'; // use lazy load components
import './core/lazy_use'; // use lazy load components
import './permission'; // permission control
import './utils/filter'; // global filter
import './global.less'; // global style

Vue.config.productionTip = false;

// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios);
// use pro-layout components
Vue.component('pro-layout', ProLayout);
Vue.component('page-container', PageHeaderWrapper);
Vue.component('page-header-wrapper', PageHeaderWrapper);

window.umi_plugin_ant_themeVar = themePluginConfig.theme;

// const resizeError = (event) => {
//   console.log('监听size:', event);

//   if (
//     event.message &&
//     (event.message.includes('ResizeObserver loop') ||
//       event.message.includes('ResizeObserver loop completed with undelivered notifications.'))
//   ) {
//     // 移除监听器
//     window.removeEventListener('error', resizeError);
//     // 阻止错误冒泡
//     event.preventDefault();
//     event.stopPropagation();
//     return false;
//   }
// };
// // 在 main.js 或应用入口处添加
// window.addEventListener('error', resizeError);

new Vue({
  router,
  store,
  i18n,
  // init localstorage, vuex, Logo message
  created: bootstrap,
  render: (h) => h(App),
}).$mount('#app');
